/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendResourceTag {
    getFixupPrototypeFunction() { return InfraResourceTrendResourceTag.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendResourceTag>): InfraResourceTrendResourceTag {
        let obj = Object.assign(new InfraResourceTrendResourceTag(), model);
        InfraResourceTrendResourceTag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendResourceTag>): InfraResourceTrendResourceTag {
        if (!model) return null;
        return InfraResourceTrendResourceTag.newInstance(<InfraResourceTrendResourceTag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendResourceTag) {
        if (!obj) return;

        models.InfraResourceTrendResourceTag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendResourceTag): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendResourceTag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag key
     */
    key: string;

    /**
     * Tag value
     */
    value: string;

}
